import { render } from "./CustOtherPgCalculator.vue?vue&type=template&id=4f55bf44"
import script from "./CustOtherPgCalculator.vue?vue&type=script&lang=js"
export * from "./CustOtherPgCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__